export const setEmailSessionStorage = (email) => sessionStorage.setItem('magic-link-email', email);
export const setMagicTokenSessionStorage = (token) => sessionStorage.setItem('magic-link-url', token);
export const getEmailSessionStorage = () => sessionStorage.getItem('magic-link-email');
export const getMagicTokenSessionStorage = () => sessionStorage.getItem('magic-link-url');
